
import { Options } from "vue-class-component";
import NodesConfigMixins from "../NodesConfigMixins";
@Options({
    name: "flowable-nodes-root-node-config",
})
export default class RootNodeConfig extends NodesConfigMixins {}
